import { useState, useRef, useEffect } from 'react'
import { Box, Text, Flex, Popover, PopoverTrigger, PopoverContent, PopoverBody, Circle, HStack, VStack, Icon } from '@chakra-ui/react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'

export function ColorSelector({ value, onChange, options = [], isDisabled, hasError }) {
  const [isOpen, setIsOpen] = useState(false)
  const triggerRef = useRef()
  const selectedColor = options.find((opt) => opt.nome_cor === value) || { nome_cor: 'Selecione', hexa_cor: '#CCCCCC' }

  // Organizar cores em linhas para exibição em grid
  const colorsPerRow = 5
  const colorRows = []

  for (let i = 0; i < options.length; i += colorsPerRow) {
    colorRows.push(options.slice(i, i + colorsPerRow))
  }

  const handleColorSelection = (color) => {
    onChange?.('cor', color.nome_cor)
    setIsOpen(false)
  }

  // Fechar o popover quando clicar fora dele
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (triggerRef.current && !triggerRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <Popover
      isOpen={isOpen && !isDisabled}
      onClose={() => setIsOpen(false)}
      placement="bottom"
      autoFocus={false}
      isLazy
      strategy="fixed" // Usa posição fixa para evitar problemas de clipping
      zIndex={1500} // Aumenta o z-index para garantir que fique acima de outros elementos
      gutter={8} // Adiciona um espaçamento para evitar que cole no elemento
    >
      <PopoverTrigger>
        <Box
          ref={triggerRef}
          onClick={() => !isDisabled && setIsOpen(!isOpen)}
          border="1px"
          borderColor={hasError ? 'red.500' : '#313E44'}
          borderRadius="8px"
          p={2}
          cursor={isDisabled ? 'not-allowed' : 'pointer'}
          maxW="222px"
          w="full"
          opacity={isDisabled ? 0.6 : 1}
          bg="transparent"
        >
          <Flex alignItems="center" justifyContent="space-between">
            <Flex alignItems="center">
              <Circle size="20px" bg={selectedColor.hexa_cor} mr={2} borderWidth="1px" borderColor="gray.300" />
              <Text fontSize="12px" color="#313E44">
                {selectedColor.nome_cor}
              </Text>
            </Flex>
            <Icon as={isOpen ? FiChevronUp : FiChevronDown} />
          </Flex>
        </Box>
      </PopoverTrigger>

      <PopoverContent width="240px" borderRadius="8px" zIndex={1500}>
        <PopoverBody p={2}>
          <VStack align="stretch" spacing={2}>
            {colorRows.map((row, rowIndex) => (
              <HStack key={rowIndex} spacing={2} justify="center">
                {row.map((color) => (
                  <Circle
                    key={color.hexa_cor}
                    size="28px"
                    bg={color.hexa_cor}
                    cursor="pointer"
                    onClick={() => handleColorSelection(color)}
                    borderWidth="1px"
                    borderColor={color.nome_cor === value ? 'blue.500' : 'gray.300'}
                    boxShadow={color.nome_cor === value ? '0 0 0 2px rgba(66, 153, 225, 0.6)' : 'none'}
                    _hover={{
                      transform: 'scale(1.1)',
                      borderColor: 'gray.400',
                    }}
                  />
                ))}
              </HStack>
            ))}
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
